// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AppRoutes from './AppRoutes'; // ✅ import the new route component
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation } from "react-router-dom";
import { pageView } from "./analytics";
import { useEffect } from 'react';
function App() {
  const location = useLocation();

  useEffect(() => {
    pageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return (
    <div style={{ backgroundColor: '#f0f2f5', minHeight: '100vh' }}>
      <AuthProvider>
          <AppRoutes /> {/* ✅ Use it here, NOT inside <Routes> */}
      </AuthProvider>
    </div>
  );
}

export default App;
